import moment from "moment";


// 日期转换
const date = (value, formatter = "time") => {
    if (value == null) {
        return "";
    }
    let fmt = formatter;
    if (fmt === "datetime") {
        fmt = "YYYY-MM-DD HH:mm:ss";
    } else if (fmt === "date") {
        fmt = "YYYY-MM-DD";
    } else if (fmt === "time") {
        fmt = "HH:mm:ss";
    } else if (fmt === "time2") {
        fmt = "HH:mm";
    }
    return moment(value).format(fmt);
};


const stateText = (type, all) => {
    if (all == null) {
        console.error(`error call stateText(${type}, null)`);
        return "";
    }
    if (!Array.isArray(all)) {
        all = [all];
    }

    const state = all.find(v => v.type == type);
    return state ? state.name : "";
}
export {
    date,
    stateText
}
